import { Pipe, PipeTransform, Sanitizer, SecurityContext } from '@angular/core';
import { noop } from 'rxjs';

@Pipe({name: 'formatPersonalText'})
export class FormatPersonalTextPipe implements PipeTransform {

  constructor(private sanitizer: Sanitizer){}

  transform(value: any, ...args: any[]) {
    switch (args[0]){
      case 'obli':
        return `${value} *`;
      case 'min':
        return `${value} Min`;
      case 'kg' :
        return `${value} Kg`;
      case 'bold' :
        const regex = /[\*][\w\W]*[\*]/gmi;
        return this.sanitize(this.replace(value, regex));
      case 'distRuta' :
        if (value > 1000) {
          value = value / 1000;
          return `${parseFloat(value).toFixed(2)}Km`;
        } else {
          return `${parseFloat(value).toFixed(2)}m`;
        }
      case 'durRuta' :
        let hour: any;
        let minute: any;
        let second: any;
        if (value > 3600) {
          hour = Math.floor(value / 3600);
          hour = (hour < 10) ? '0' + hour : hour;
        } else {
          hour = 0;
        }
        minute = Math.floor((value / 60) % 60);
        minute = (minute < 10) ? '0' + minute : minute;
        second = value % 60;
        second = (second < 10) ? '0' + second : second;

        if (hour > 0){
          return `${hour}h, ${minute}min, ${parseInt(second, 10)}s`;
        } else {
          return `${minute}min, ${parseInt(second, 10)}s`;
        }
      case 'dirStepRuta_right':
      case 'dirStepRuta_slight right':
        return 'pi pi-arrow-right';
      case 'dirStepRuta_left':
      case 'dirStepRuta_slight left':
        return 'pi pi-arrow-left';
      case 'dirStepRuta_straight':
        return 'pi pi-arrow-up';
      case 'dirStepRuta_sharp right':
        return 'pi pi-arrow-right';
      case 'dirStepRuta_sharp left':
        return 'pi pi-arrow-left';
      case 'dirStepRuta_depart':
        return 'pi pi-circle-off';
      case 'dirStepRuta_arrive':
        return 'pi pi-circle-on';
      case 'resumenNoticia':
        return `${value} ...`;
      default:
        return value;
    }
  }

  private replace(str, regex) {
    const matched = str.match(regex);
    matched ? matched.forEach(foundString => {
      foundString = foundString.substring(1, foundString.length - 1);
      str = str.replace(regex, `<b>${foundString}</b>`);
    }) : noop;
    return str;
  }

  private sanitize(str) {
    return this.sanitizer.sanitize(SecurityContext.HTML, str);
  }
}
